import { BigNumber } from 'ethers';
import { NFTCartItem } from '@app/state/nftCartStore';
import { NFTMarketplaceListing } from '@app/types/nftMarketplace';
import { Token } from '@app/types/token';
import { formatUnits } from 'ethers/lib/utils';

export type CartSubtotals = Map<
  string,
  {
    token: Token;
    total: BigNumber;
  }
>;

export type FormattedSubtotalPerCurrency = {
  token: Token;
  formattedSubtotal: string;
};

export const calculateSubtotalsPerCurrency = (
  listings: NFTMarketplaceListing[],
  TOKENS_WHITELIST: Token[]
) => {
  const subtotals: CartSubtotals = new Map();

  listings.forEach(listing => {
    const token = TOKENS_WHITELIST.find(
      item =>
        item.contractAddress.toLowerCase() === listing.currency.toLowerCase()
    );
    const currencyKey = listing.currency;

    if (!subtotals.has(currencyKey)) {
      subtotals.set(currencyKey, {
        token: token as Token,
        total: BigNumber.from(0)
      });
    }

    const group = subtotals.get(currencyKey)!;

    if (listing.isNFTAvailable) {
      group.total = group.total.add(BigNumber.from(listing.price));
    }
  });

  return subtotals;
};

export const getFormattedSubtotalPerCurrency = (groups: CartSubtotals) => {
  const subtotals: FormattedSubtotalPerCurrency[] = [];

  for (const [currencyKey, group] of groups.entries()) {
    const formattedSubtotal = formatUnits(group.total, group.token.decimals);

    subtotals.push({
      token: group.token,
      formattedSubtotal: formattedSubtotal
    });
  }

  return subtotals;
};

export const formatCurrenciesToCheckAllowance = (
  groupedTotalsByCurrency: CartSubtotals
) => {
  let currenciesToCheckAllowance: Token[] = [];

  groupedTotalsByCurrency.forEach(group => {
    currenciesToCheckAllowance.push(group.token);
  });

  return currenciesToCheckAllowance;
};
